import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { ButtonArrange, CellulaFormSubmitData, Flex, Form, InputCheckbox, InputCheckboxGroup } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { Skeleton } from '../../components/skeleton';
import { useAccess } from './use_access';

export const ScreenAccess = () => {
	const { data, status, submit } = useAccess();
	const { trackEvent } = useAnalyticContext();

	const handleAccessChange = (value: string[]) => {
		trackEvent(`Changed "Access" to "${value}"`);
	};

	const handleSubmit = (formData: CellulaFormSubmitData) => {
		submit({ access: formData.access });
	};

	const handleInvalidSubmit = () => {
		trackEvent('Form is invalid');
	};

	if (status !== 'accessible' || data.persons.length === 0) {
		return <Skeleton />;
	}

	const mePersons = data.persons.filter((p) => p.isMe);
	const subjectPersons = data.persons.filter((p) => p.isSubject && !p.isMe);
	const otherPersons = data.persons.filter((p) => !p.isMe && !p.isSubject);
	const defaultAccess = [
		...new Set([
			...mePersons.map((p) => p.identityNumber),
			...subjectPersons.map((p) => p.identityNumber),
			...data.selectedIdentityNumbers,
		]),
	];

	return (
		<>
			<TopBar.Content goBack />

			<Flex grow={1} gap={tokens.spacing.x2}>
				<Form.Root
					options={{
						defaultValues: {
							access: defaultAccess,
						},
						mode: 'onBlur',
					}}
					onSubmit={handleSubmit}
					onInvalid={handleInvalidSubmit}
				>
					<Flex grow={1} gap={tokens.spacing.x2}>
						<Title title={withTranslation('View.Booking.ScreenAccess.Title')} titleSize='small' />
						<Flex gap={tokens.spacing.x2}>
							<InputCheckboxGroup
								label={withTranslation('View.Booking.ScreenAccess.Input.Label.access')}
								variant='outlined'
								required
								name='access'
								onChange={handleAccessChange}
							>
								{mePersons.map((person) => (
									<InputCheckbox
										key={person.identityNumber}
										label={withTranslation('View.Booking.ScreenAccess.Option.Me', { name: person.name })}
										value={person.identityNumber}
										readOnly
										checked
									/>
								))}
								{subjectPersons.map((person) => (
									<InputCheckbox key={person.identityNumber} label={person.name} value={person.identityNumber} readOnly checked />
								))}
								{otherPersons.map((person) => (
									<InputCheckbox key={person.identityNumber} label={person.name} value={person.identityNumber} />
								))}
							</InputCheckboxGroup>
						</Flex>
					</Flex>

					<ButtonArrange>
						<Form.SubmitButton onClick={() => trackEvent('Clicked next button')}>
							{withTranslation('PW.Common.Next')}
						</Form.SubmitButton>
					</ButtonArrange>
				</Form.Root>
			</Flex>
		</>
	);
};
